// @flow

import React from 'react';
import styles from './theme.less';
import { getCurrentRating } from 'src/modules/app-install-banner';
import { Section, Strong, Text, Button } from 'seek-style-guide/react';
import { currentDevice } from 'src/modules/chalice-user-agent/device-detect';
import SVGAppIcon from './svg-app-icon';
import ScrollLock from 'react-scrolllock';

import { isShortDevice } from 'src/modules/responsive-helpers';

const stubFunction = () => {};

const BannerWithBackgroundImage = ({
  active,
  titleCopy,
  onClick,
  onDismiss
}: {
  active: boolean,
  titleCopy: string,
  onClick: Function,
  onDismiss: Function
}) => {
  const { reviewQuote } = getCurrentRating(currentDevice());

  return (
    <div className={styles.root}>
      {active && <ScrollLock />}
      <Section onClick={onClick}>
        <SVGAppIcon svgClass={styles.appIconPlaceHolder} />
        <Text className={styles.appStoreText} heading>
          {titleCopy}
        </Text>
        {reviewQuote && !isShortDevice() && (
          <div className={styles.quote}>
            <span className={styles.openingQuote}>&#10077;</span>
            <Text>{reviewQuote}</Text>
            <span className={styles.closingQuote}>&#10078;</span>
          </div>
        )}
      </Section>
      <Section slim>
        <Button onClick={onClick} color="pink" fullWidth={true}>
          <Strong>Try the app</Strong>
        </Button>
        <Button
          className={styles.noThanks}
          onClick={onDismiss}
          color="transparent"
          fullWidth
        >
          No, thanks
        </Button>
      </Section>
    </div>
  );
};

export default ({
  active,
  onClick = stubFunction,
  onDismiss = stubFunction
}: {
  active: boolean,
  onClick: Function,
  onDismiss: Function
}) => {
  const bannerProps = {
    active,
    onClick,
    onDismiss
  };

  const reviewsBannerProps = {
    ...bannerProps,
    titleCopy: 'Try the SEEK app to find your dream job faster.'
  };

  return <BannerWithBackgroundImage {...reviewsBannerProps} />;
};
